/**
 * verticalCard.tsx
 */
import Card from '@shared/types/props/card';
import Container from '@components/atoms/container/verticalCardContainer';
import Image from '@components/atoms/images/verticalCardImage';
import Info from '@components/elements/card/ui/info/verticalCardInfo';
import useVerticalCard from '@components/elements/card/lib/useVerticalCard';
import { memo } from 'react';

/**
 * Vertical card component. Represents a single vertical card in the vertical rail.
 * Handles lazy loading, focus states, and asset updates on hover.
 *
 * @param {Props} props - Component props including item, index, and onClick handler
 * @returns {JSX.Element | null} Vertical card element or null if not in view
 */

function VerticalCard(parentProps: Card) {
  // Card hook
  const { props } = useVerticalCard({ ...parentProps });

  // Render
  return (
    <Container
      id={'verticalCardContainer'}
      focused={parentProps.focused}
      hide={parentProps.hide}
      {...props.container}
    >
      <Image {...props.image} />
      <Info {...props.info} />
    </Container>
  );
}

export default memo(VerticalCard);
